
  import {defineComponent} from "vue";
  import router from "@/router";
  import JsBarcode from "jsbarcode";
  import {NamedRouting} from "@/domain/utils/NamedRouting";

  export default defineComponent({
    name: 'ticket-info-component',
    props: ['ticket', 'product', 'approval'],
    data() {
      return {
        showTicket: false,
        copyAlert: false,
      }
    },
    created() {
      this.showTicket = this.ticket.isUsable;
    },
    mounted() {
      if (this.canShowTicket && this.ticket.isBarcodeType) {
        JsBarcode(".barcode_img", this.ticket.ticketPinNumber, {
          margin: 0,
          displayValue: false,
        });
      }
    },
    methods: {
      toggleTicket(): void {
        this.showTicket = !this.showTicket;
      },
      applyForRefund(): void {
        // TODO: 황불신청기능 테스트
        window.open(process.env.VUE_APP_TICKET_SERVER_URL);
      },
      moveToRefundingHistory(): void {
        router.push(new NamedRouting('RefundingHistoryView', {ticketId: this.ticket.ticketId}));
      },
      // TODO: 바코드 컴포넌트 나누기
      copyClipboard(val: string): void {
        const tempArea = document.createElement("textarea");
        document.body.appendChild(tempArea);
        tempArea.value = val;
        tempArea.select();
        document.execCommand("copy");
        this.copyAlert = true;
        document.body.removeChild(tempArea);
        setTimeout(() => {
          this.copyAlert = false;
        }, 1500);
      },
    },
    computed: {
      canShowTicket(): boolean {
        return this.ticket.isUsable || this.ticket.isUsed || this.ticket.isRefundable;
      }
    }
  });
